var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeLongAbsence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h5v3h-8V9h3v5zM30.57 32.8A5.55 5.55 0 0132 36v12c0 2.23-2.19 4-4.5 4-.166.01-.334.01-.5 0v7h33V37.17L43.5 23.74 30.57 32.8zM73 14.42A11.41 11.41 0 1161.58 3 11.43 11.43 0 0173 14.42zm-3 0a8.41 8.41 0 10-8.42 8.41A8.43 8.43 0 0070 14.42zM20.17 31a3 3 0 100-5.999 3 3 0 000 5.999zM29 47.5V37a4 4 0 00-.8-2.39A3.999 3.999 0 0025 33H15a4 4 0 00-4 4v10.5a1.5 1.5 0 103 0V37a1 1 0 011-1h1v27.5a1.5 1.5 0 103 0V51h2v12.5a1.5 1.5 0 103 0V36h1a1.08 1.08 0 011 1v10.5a1.5 1.5 0 103 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_long_absence.7c13aed0.svg";
export { SvgF1ModeLongAbsence as ReactComponent };